import { render } from "./p4Page.vue?vue&type=template&id=37f60385&scoped=true"
import script from "./p4Page.vue?vue&type=script&lang=js"
export * from "./p4Page.vue?vue&type=script&lang=js"

import "./p4Page.vue?vue&type=style&index=0&id=37f60385&scoped=true&lang=css"

import exportComponent from "/Users/song/Desktop/pro/homePage/沙漠传说/desertlegendhomepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f60385"]])

export default __exports__